const itemClasses = [
  { value: 0, name: 'Labor' },
  { value: 1, name: 'Equipment' },
  { value: 2, name: 'Materials' },
  { value: 3, name: 'Subcontracting' },
  { value: 4, name: 'Activity' },
  { value: 99, name: 'Other' },
]
export default itemClasses
